<template>
  <radio
    :aria-label="` ${field.datahash.label}; ${statement.label}; ${value.label}`" :value="value"
    :required="required"
    :model-value="storeAnswer.checked ? value : ''"
    :allowDeselect="true"
    :error="isInvalid"
    @customClick="handleChange"
    main-class="inline-flex"
  />
</template>
<script>
import editMixin from './_mixin_display_base';
import { useFormResultStore } from '../../stores/form_result';
import radio from '../_radio.vue';

export default {
  components: { radio },
  props: {
    field: {},
    statement: {},
    value: {},
    parentAnswered: {},
    parentRequired: {},
  },
  emits: ['update'],
  data: ()=>({
    answer: {},
    formResultStore: {},
  }),
  inject: ['formResult'],
  computed: {
    answered(){
      return this.formResultStore.answersByFieldAndOption(this.field.id, this.statement.option_id).some(answer=> answer.checked === true)
    },
    lookupAnswer(){
      return this.answerInit(
        this.field,
        this.statement,
        this.value,
      )
    },
    storeAnswer(){ return this.formResultStore.getAnswer(this.lookupAnswer) },
    required(){ return this.parentRequired},
    classes(){
      return {
        'ng-valid': this.answered,
        'ng-invalid': this.required && !this.answered
      }
    },
    isInvalid(){ return this.required && !this.answered},
  },
  watch: {
    // "storeAnswer.checked"(val){ this.answer.checked = val},
    // "storeAnswer.id"(val){ this.answer.id = val},
  },
  created () {
    this.formResultStore = useFormResultStore(this.formResult)
    const answer = this.formResultStore.findAnswer(this.lookupAnswer) || this.lookupAnswer
    this.formResultStore.addAnswer(answer)
  },
  methods:{
    handleChange(){
      this.$emit('update', this.storeAnswer)
    },
    answerInit(...args){
      return this.likertAnswerInit(...args)
    },
    likertAnswerInit(field, statement, value) {
      let answer = editMixin.methods.initializeAnswer(field, {
        checked: ((value.checked === true) ? true : false),
        data: {
          value: value.label,
          score: value.score,
          field_option_label: value.label,
          field_statement_label: statement.label
        },
        likert_id: value.column_id, // column
        option_id: statement.option_id // row
      }, {form_result: this.formResult});
      return answer;
    },
  }
}
</script>
